.menu {
  display: none;
  position: relative;
  z-index: 1000;
  flex-direction: row;
  align-items: center;
  height: var(--header-height);
  min-height: var(--header-height);
  border-bottom: 1px rgba(255, 255, 255, 0.16) solid;
  max-width: 100%;

  @media screen and (min-width: $bp-medium) {
    display: flex;
  }
}

.phases {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.8rem;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  gap: 0.8rem;

  &::-webkit-scrollbar {
    display: none;
  }
}
